import React, { useState, useEffect } from "react";
import { WordPressUserAuth } from "@/integrations/wordpress/WordPressUserAuth";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
export function FeaturedProductsConsumer() {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [authChecked, setAuthChecked] = useState<boolean>(false);
  useEffect(() => {
    let isMounted = true;
    const auth = new WordPressUserAuth();
    const checkAuth = async () => {
      try {
        const result = await auth.getCurrentUser();
        if (isMounted) {
          setIsLoggedIn(Boolean(result?.success));
          setAuthChecked(true);
        }
      } catch (err) {
        if (isMounted) {
          setIsLoggedIn(false);
          setAuthChecked(true);
        }
      }
    };
    checkAuth();
    return () => {
      isMounted = false;
    };
  }, []);
  if (!authChecked) {
    return <div>Loading authentication...</div>;
  }
  return <EcommerceProductsProvider>
      <div className="featured-products">
        {/* Your component UI */}
        {isLoggedIn ? <p>Welcome back!</p> : <p>Please log in to see exclusive pricing.</p>}
      </div>
    </EcommerceProductsProvider>;
}
export default FeaturedProductsConsumer;